export enum HealthScoreEnum {
	ON_TRACK = 'onTrack',
	MINOR_RISK = 'minorRisk',
	MAJOR_RISK = 'majorRisk',
}
